import api from "./core";

const basePath = "api/{{serverSegment}}/UserResponses";

export default {
  create(data) {
    return api.put(`${basePath}`, data, {
      "Hide-Loading": true
    });
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`, {
      "Hide-Loading": true
    });
  },
  query(formId, componentId) {
    return api.get(`${basePath}/${formId}/${componentId}`, {
      "Hide-Loading": true
    });
  }
};